export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAIL = 'GET_USERS_FAIL';

export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAIL = 'GET_PROJECTS_FAIL';

export const GET_CLICKED_USER_SUCCESS = 'GET_CLICKED_USER_SUCCESS';
export const GET_CLICKED_USER_FAIL = 'GET_CLICKED_USER_FAIL';

export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_FAIL = 'GET_ROLES_FAIL';

export const GET_USER_BY_ID_SUCCESS = 'GET_USER_BY_ID_SUCCESS';
export const GET_USER_BY_ID_FAIL = 'GET_USER_BY_ID_FAIL';

export const GET_ALL_ACCESSIBILITIES_SUCCESS =
	'GET_ALL_ACCESSIBILITIES_SUCCESS';
export const GET_ALL_ACCESSIBILITIES_FAIL = 'GET_ALL_ACCESSIBILITIES_FAIL';

export const GET_PROJECT_LIST_BY_ID_SUCCESS = 'GET_PROJECT_LIST_BY_ID_SUCCESS';
export const GET_PROJECT_LIST_BY_ID_FAIL = 'GET_PROJECT_LIST_BY_ID_FAIL';

export const GET_ROLES_ACCESSIBILITIES_SUCCESS =
	'GET_ROLES_ACCESSIBILITIES_SUCCESS';
export const GET_ROLES_ACCESSIBILITIES_FAIL = 'GET_ROLES_ACCESSIBILITIES_FAIL';

export const GET_ACCESSIBILITIES_BY_ROLE_SUCCESS =
	'GET_ACCESSIBILITIES_BY_ROLE_SUCCESS';
export const GET_ACCESSIBILITIES_BY_ROLE_FAIL =
	'GET_ACCESSIBILITIES_BY_ROLE_FAIL';

export const GET_ARCHIVED_USERS_SUCCESS = 'GET_ARCHIVED_USERS_SUCCESS';
export const GET_ARCHIVED_USERS_FAIL = 'GET_ARCHIVED_USERS_FAIL';

export const GET_ROLES_ALL_PROJECTS_SUCCESS = 'GET_ROLES_ALL_PROJECTS_SUCCESS';
export const GET_ROLES_ALL_PROJECTS_FAIL = 'GET_ROLES_ALL_PROJECTS_FAIL';

export const SET_PROJECT_SELECTED_CODE = 'SET_PROJECT_SELECTED_CODE';

export const CLEAR_USER_BY_ID = 'CLEAR_USER_BY_ID';
